import styles from "./FlotteTable.module.scss";
import LicensePlate from "../../../../common/LicensePlate/LicensePlate";
// Composant d'aide visuelle

const SummaryCard = ({
  marque,
  modele,
  immatriculation,
  client,
  duree_contrat,
  km_contrat,
  anomalies_facturation = [],
  top,
}) => {
  const formatDuree = (duree) => {
    if (!duree) return "N/A";
    return `${duree} mois`;
  };

  const formatKilometrage = (km) => {
    if (!km) return "N/A";
    return `${km.toLocaleString()} km`;
  };

  return (
    <div
      className={styles.summaryCard}
      style={{
        position: "fixed",
        left: "10px",
        top: `${top - 10}px`,
        zIndex: 1000,
        backgroundColor: "#fff",
        border: "1px solid #dee2e6",
        borderRadius: "8px",
        padding: "12px",
        minWidth: "280px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        fontSize: "0.875rem",
      }}
    >
      <div className="d-flex flex-column">
        <div className="mb-1">
          <strong className="text-primary d-flex justify-content-between">
            <span>
              {marque || "N/A"} {modele || ""}
            </span>
            <LicensePlate
              value={immatriculation}
              size="sm"
              copyable={false}
              className={styles.summaryCardPlate}
            />
          </strong>
        </div>
        <div className="mb-1 text-muted small">
          <i className="fas fa-user mr-1"></i>
          {client || "Client non renseigné"}
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <span className="text-muted small">
          <i className="fas fa-clock mr-1"></i>
          {formatDuree(duree_contrat)}
        </span>
        <span className="text-muted small">
          <i className="fas fa-tachometer-alt mr-1"></i>
          {formatKilometrage(km_contrat)}
        </span>
      </div>
      {/* LS-742 : causes de l'anomalie de facturation, lisibles sans ouvrir le véhicule */}
      {anomalies_facturation.length > 0 && (
        <div
          className="mt-2 pt-2 text-danger small"
          style={{ borderTop: "1px solid #dee2e6" }}
        >
          <strong>
            <i className="fas fa-exclamation-triangle mr-1"></i>
            Anomalie de facturation
          </strong>
          <ul className="mb-0 pl-3">
            {anomalies_facturation.map((cause) => (
              <li key={cause}>{cause}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
